import request from '@/utlis/request'

// 登录接口
export function getLoginApi (params) {
  return request({
    url: '/op/user/login',
    method: 'post',
    params
  })
}

// 注册接口
export function getaddXFUserApi (params) {
  return request({
    url: '/op/user/addXFUser',
    method: 'post',
    params
  })
}
// 重置密码接口
export function resetPasswordApi (data) {
  return request({
    url: '/op/user/update/password',
    method: 'post',
    data:data
  })
}

// 获取 验证码
export function getEmailApi (phone, code, uuid) {
  return request({
    url: '/op/user/getCode',
    method: 'get',
    params: { phone, code, uuid }
  })
}

// 手机号验证接口
export function getPhoneCodeApi (params) {
  return request({
    url: '/op/user/checkCode',
    method: 'get',
    params: params
  })
}

// 获取登录验证码图片
export function getCaptchaImageApi () {
  return request({
    url: '/op/user/captchaImage',
    method: 'get',
  })
}


// 获取登录验证码图片
export function getCodeApi () {
  return request({
    url: '/op/user/captchaImage',
    method: 'get',
  })
}


// 加载所有的民族信息
export function getNations() {
  return request({
    url: '/system/nation/list/all',
    method: 'get'
  })
}
